import { articleImages } from './categories';

export const articles = [
  {
    id: 1,
    slug: 'nupu-liyi-rumen-zhinan',
    title: '女仆礼仪入门指南：从零开始成为优雅的女仆',
    excerpt: '掌握基础礼仪是成为专业女仆的第一步。本文从站姿、坐姿、行走姿态到问候礼仪，全面介绍女仆礼仪的核心要点。',
    content: `<p>女仆礼仪是女仆职业培训中最基础也最关键的一环。优雅得体的举止不仅体现了女仆的专业素养，更是客户满意度的核心保障。</p>
<h2>一、基本站姿与仪态</h2>
<p>专业女仆的站姿要求身体挺直、双肩放松、下颌微收。站立时双脚并拢呈V字形，双手自然交叠置于身前，展现出端庄大方的形象。在日常服务中，女仆应始终保持良好的体态，避免倚靠墙壁或家具。</p>
<h2>二、行走姿态规范</h2>
<p>女仆行走时应步伐轻盈、步幅适中，上身保持平稳。在走廊或房间内移动时，应靠右侧行走，遇到客人时主动侧身让行并微微颔首致意。端着托盘行走时，要注意保持托盘平稳，步伐更加谨慎。</p>
<h2>三、问候与应对礼仪</h2>
<p>问候是女仆与主人或客人建立良好关系的第一步。标准的问候语应清晰、温和，同时配合得体的鞠躬礼。根据场合的不同，鞠躬的角度和问候语也需相应调整——日常问候使用15度微躬，正式场合使用30度鞠躬。</p>
<h2>四、餐桌服务礼仪</h2>
<p>在餐桌服务中，女仆需要掌握上菜顺序、餐具摆放、饮品斟倒等专业技能。上菜时应从客人的左侧上菜、右侧撤盘。斟茶或咖啡时，杯子的把手应朝向客人的右手方向。</p>`,
    category: 'liyi-guifan',
    image: articleImages['art-liyi-1'],
    date: '2024-12-15',
    readTime: '8分钟',
  },
  {
    id: 2,
    slug: 'gaoduan-canju-baifang-jiqiao',
    title: '高端餐具摆放技巧：打造完美餐桌艺术',
    excerpt: '精美的餐桌布置是女仆服务中的重要环节。学习餐具种类识别、规范摆放顺序与餐桌装饰搭配技巧。',
    content: `<p>高端餐具的摆放是一门需要精心学习的艺术。一个布置得当的餐桌能极大提升用餐体验，也是女仆专业能力的直接体现。</p>
<h2>一、餐具种类识别</h2>
<p>标准西式餐具包括主餐刀、主餐叉、汤匙、甜品叉、甜品匙、黄油刀等。每种餐具有其特定的用途和摆放位置。女仆应能快速识别各种餐具并了解其使用场景。</p>
<h2>二、标准摆放规范</h2>
<p>餐具摆放遵循"由外向内"的使用顺序原则。主餐叉置于餐盘左侧，主餐刀置于右侧（刀刃朝向餐盘），汤匙放在主餐刀的右侧。甜品餐具横向置于餐盘上方。</p>
<h2>三、酒杯与饮具配置</h2>
<p>酒杯应按照使用顺序从左至右排列于餐盘的右上方。通常包括水杯、红酒杯、白酒杯。各杯之间保持适当间距，形成协调的弧线排列。</p>`,
    category: 'liyi-guifan',
    image: articleImages['art-liyi-2'],
    date: '2024-11-28',
    readTime: '6分钟',
  },
  {
    id: 3,
    slug: 'richang-qingjie-liucheng-guifan',
    title: '日常清洁流程规范：高效专业的空间管理术',
    excerpt: '专业女仆的清洁工作远不止表面打扫，本课程详细讲解分区清洁法、工具选用标准与验收标准。',
    content: `<p>清洁工作是女仆日常服务中占比最大的部分，掌握科学的清洁流程能大幅提升工作效率和服务质量。</p>
<h2>一、分区清洁法</h2>
<p>将工作区域划分为干区（客厅、卧室、书房）和湿区（厨房、卫生间、浴室），采用不同的清洁策略和工具，避免交叉污染。</p>
<h2>二、清洁工具选用标准</h2>
<p>选择适合不同表面的清洁工具至关重要。微纤维抹布适用于家具表面，天然鬃毛刷用于精细物品，专业吸尘器配备HEPA滤网确保空气质量。</p>
<h2>三、清洁验收标准</h2>
<p>完成清洁后，需要进行系统的自检。包括表面无灰尘、镜子无水渍、地面无毛发、空气清新无异味等多项标准。</p>`,
    category: 'fuwu-jineng',
    image: articleImages['art-fuwu-1'],
    date: '2024-12-08',
    readTime: '7分钟',
  },
  {
    id: 4,
    slug: 'hongcha-chongpao-yishu',
    title: '红茶冲泡艺术：正统英式下午茶服务全解',
    excerpt: '茶艺服务是高级女仆的核心技能之一。从选茶、温杯到冲泡时间的精准把控，每一步都体现专业水准。',
    content: `<p>英式下午茶服务是女仆职业技能中的亮点。一场完美的下午茶不仅需要优质的茶叶，更需要女仆专业优雅的服务。</p>
<h2>一、茶叶选择与储存</h2>
<p>了解大吉岭、阿萨姆、锡兰、伯爵茶等主要红茶品种的特点和适宜饮用时段。茶叶应密封储存在阴凉干燥处，避免阳光直射和异味污染。</p>
<h2>二、冲泡流程详解</h2>
<p>正统冲泡流程包括：温壶、投茶、注水、浸泡、过滤。水温应控制在95-98°C，浸泡时间根据茶叶品种在3-5分钟之间调整。</p>
<h2>三、三层点心架搭配</h2>
<p>下午茶点心的摆放遵循"由下至上、由咸到甜"的原则。底层放置三明治，中层放置司康饼，上层放置精致甜点。</p>`,
    category: 'fuwu-jineng',
    image: articleImages['art-fuwu-2'],
    date: '2024-11-20',
    readTime: '10分钟',
  },
  {
    id: 5,
    slug: 'nupu-zhiye-guihua-luxian',
    title: '女仆职业规划路线：从初级到高级的成长路径',
    excerpt: '了解女仆行业的职业阶梯体系，明确各阶段技能要求与薪资水平，制定个人职业发展规划。',
    content: `<p>女仆行业的职业发展路径清晰明确，从入门到高级，每个阶段都有对应的技能要求和成长方向。</p>
<h2>一、初级女仆（入门级）</h2>
<p>初级女仆主要负责基础清洁、简单备餐等日常家务。要求掌握基本礼仪规范和清洁技能，通常需要经过3-6个月的系统培训。月薪范围：6000-9000元。</p>
<h2>二、中级女仆（专业级）</h2>
<p>中级女仆能够独立完成全面的家务管理，包括精细清洁、正餐准备、衣物护理等。需要1-2年工作经验并取得相关认证。月薪范围：10000-18000元。</p>
<h2>三、高级女仆（管家级）</h2>
<p>高级女仆具备全面的家政管理能力，可统筹管理多项事务，同时精通茶艺、插花等高阶技能。通常需要3年以上经验和多项专业认证。月薪范围：20000-35000元。</p>`,
    category: 'zhiye-fazhan',
    image: articleImages['art-zhiye-1'],
    date: '2024-12-20',
    readTime: '9分钟',
  },
  {
    id: 6,
    slug: 'nupu-fushi-dapei-zhinan',
    title: '女仆服饰搭配指南：从经典到现代的制服美学',
    excerpt: '女仆制服不仅代表职业身份，更是审美品味的体现。学习不同风格制服的搭配原则与穿着礼仪。',
    content: `<p>女仆制服是职业形象的重要组成部分。得体的穿着不仅提升专业感，还能增强客户的信任和好感。</p>
<h2>一、经典英式女仆装</h2>
<p>经典款以黑色连衣裙搭配白色围裙和头饰为主，线条简洁大方。适合正式场合和传统风格的家庭服务。</p>
<h2>二、现代改良款制服</h2>
<p>现代款在保留经典元素的基础上，加入了更符合当代审美的设计。面料选择更加考究，版型更加合体。</p>
<h2>三、穿着与保养规范</h2>
<p>制服应保持整洁无褶皱，每日更换清洗。头饰应端正佩戴，鞋子需保持光亮。制服出现破损应及时更换。</p>`,
    category: 'fuwu-jineng',
    image: articleImages['art-fuwu-3'],
    date: '2024-10-15',
    readTime: '7分钟',
  },
  {
    id: 7,
    slug: 'nupu-hangye-fazhan-qushi',
    title: '女仆行业发展趋势：2025年市场分析与机遇',
    excerpt: '深度剖析女仆服务行业的市场规模、需求变化与未来发展方向，为从业者提供前瞻性职业指导。',
    content: `<p>随着高端家政服务市场的快速发展，专业女仆的需求量持续增长。了解行业趋势对于职业规划至关重要。</p>
<h2>一、市场规模与增长</h2>
<p>据统计，中国高端家政服务市场规模已突破3000亿元，其中专业女仆服务占比逐年提升。预计到2025年，专业女仆的年需求增长率将达到25%以上。</p>
<h2>二、需求变化趋势</h2>
<p>现代家庭对女仆的需求已从单纯的家务劳动转变为综合性的高品质服务。外语能力、驾驶技能、营养学知识等成为加分项。</p>
<h2>三、国际化发展机遇</h2>
<p>随着中日文化交流的深入，越来越多的中国女仆从业者获得海外就业机会。具备日语或英语能力的高级女仆在国际市场上极具竞争力。</p>`,
    category: 'hangye-zhishi',
    image: articleImages['art-hangye-1'],
    date: '2024-12-25',
    readTime: '8分钟',
  },
  {
    id: 8,
    slug: 'nupu-mianshi-jiqiao',
    title: '女仆面试技巧：如何在众多候选人中脱颖而出',
    excerpt: '面试是进入理想工作岗位的关键一步。掌握面试礼仪、常见问题应对与个人优势展示技巧。',
    content: `<p>面试是展示个人素质和专业能力的最佳时机。充分的准备能让你在众多候选人中脱颖而出。</p>
<h2>一、面试前的准备</h2>
<p>了解雇主家庭背景和服务需求，准备简洁专业的个人简历和技能证书。选择得体整洁的着装，提前规划好出行路线。</p>
<h2>二、面试礼仪要点</h2>
<p>准时到达是最基本的尊重。进门时先敲门，得到允许后轻轻推门进入。面试过程中保持良好的坐姿和眼神交流。</p>
<h2>三、常见问题应对</h2>
<p>准备好回答关于工作经验、技能特长、离职原因、薪资期望等问题。回答时应诚实但不失策略，突出个人优势。</p>`,
    category: 'zhiye-fazhan',
    image: articleImages['art-zhiye-2'],
    date: '2024-11-10',
    readTime: '6分钟',
  },
  {
    id: 9,
    slug: 'riben-nupu-wenhua-yuanyuan',
    title: '日本女仆文化渊源：从传统到现代的演变历程',
    excerpt: '追溯日本女仆文化的起源，了解其从江户时代到现代女仆咖啡厅的完整演变脉络与文化内涵。',
    content: `<p>日本女仆文化有着深厚的历史渊源。了解这段文化演变历程，有助于更好地理解现代女仆服务业的精神内涵。</p>
<h2>一、江户时代的雏形</h2>
<p>女仆的概念在日本江户时代已初见雏形，当时的武家宅邸中已有专门负责家务和接待的女性佣人，她们遵循严格的等级制度和行为规范。</p>
<h2>二、明治维新时期的发展</h2>
<p>明治维新后，随着西方文化的传入，日本的女仆制度逐渐与欧洲标准接轨。这一时期出现了系统化的女仆培训体系。</p>
<h2>三、现代女仆文化的多元化</h2>
<p>进入21世纪，女仆咖啡厅的兴起让女仆文化走向大众。现代女仆服务已经从传统的家庭服务拓展到餐饮、酒店、主题乐园等多个领域。</p>`,
    category: 'hangye-zhishi',
    image: articleImages['art-hangye-2'],
    date: '2024-09-28',
    readTime: '10分钟',
  },
];

export const faqs = [
  {
    question: '女仆培训课程需要多长时间？',
    answer: '基础入门课程通常为4-6周，全日制学习模式；中级进阶课程为8-12周；高级管家级课程为16-24周。学员可根据个人时间安排选择全日制或周末制学习模式。所有课程均包含理论学习和实操训练两个部分。',
  },
  {
    question: '参加女仆培训需要什么条件？',
    answer: '基础课程对学员的基本要求为：年满18周岁，高中及以上学历，身体健康，无不良嗜好，对服务行业有热情。高级课程需要具备基础课程结业证书或相关工作经验。性别不限，我们欢迎所有有志从事女仆服务行业的人士报名。',
  },
  {
    question: '培训结束后是否推荐就业？',
    answer: '是的，我们与多家高端家政服务公司、五星级酒店、私人管家服务机构建立了稳定的合作关系。优秀学员在完成培训并通过考核后，可获得我们的就业推荐服务。往期学员就业率达到92%以上。',
  },
  {
    question: '课程费用是多少？有无分期付款方式？',
    answer: '基础礼仪课程学费为4800元，中级服务技能课程为8800元，高级管家课程为16800元。我们提供灵活的分期付款方案，支持3期、6期和12期无息分期。报名时缴纳30%定金即可锁定名额。',
  },
  {
    question: '培训地点在哪里？是否提供住宿？',
    answer: '我们的培训中心位于上海市徐汇区，交通便利，地铁直达。对于外地学员，我们提供合作公寓的优惠住宿方案，每月住宿费用约为1200-1800元。培训中心配有标准的实操训练教室、茶艺室、模拟服务场景等专业设施。',
  },
  {
    question: '课程结业后颁发什么证书？',
    answer: '学员完成全部课程并通过考核后，将获得由女仆教育颁发的专业技能培训结业证书。高级管家课程还可申请参加国际管家协会认证考试。我们的证书在业内具有广泛的认可度。',
  },
];

export const testimonials = [
  {
    name: '陈小姐',
    role: '高级女仆管家',
    content: '在女仆教育完成了从初级到高级的全部课程，老师们非常专业负责。现在我在一位企业家的家庭担任管家，这份工作让我感到非常有成就感。',
  },
  {
    name: '林女士',
    role: '五星级酒店私人管家',
    content: '培训中学习的茶艺和餐桌礼仪让我在面试中脱颖而出。课程内容非常实用，与实际工作需求完美对接。感谢女仆教育！',
  },
  {
    name: '王小姐',
    role: '日式女仆咖啡厅店长',
    content: '从一名普通店员成长为店长，女仆教育的课程给了我系统的知识和信心。特别是服务礼仪和团队管理方面的内容，对我的帮助非常大。',
  },
];